<template>
	<div>
		<div class="header">
			<div style="display: flex;align-items: center;">
				<img src="../../assets/images/indexIcon.png" alt="">
				<p><span>首页-产品服务池</span>-应助需求草稿</p>
			</div>
			<div class="backof" @click="$router.go(-1)">返回</div>
		</div>
		<div style="display: flex;justify-content: space-between;">
			<div class="left">
				<div style="background:#E5EDFB;">
					<div
						style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
						应助需求
					</div>
				</div>
				<div style="display: flex;justify-content: center;margin: 30px;">
					<div :class="['box-f',arrowStep == 1?'box-active':'']">应助需求</div>
					<div :class="['box-l',arrowStep == 3?'box-active':'']">网站审核/公布</div>
				</div>
				<div class="form-one" v-if="nowWeAre == 1">
				
					
				

					
					<div class="form-item">
						<div style="display: flex;justify-content: space-between;width: 100%;">
							<div class="jtitle">
								产品服务简介：
							</div>

						</div>
						<div class="laterUp">
						</div>
						<div style="width:90%;margin-left: 140px;margin-top: 20px;">
							<div class="item-content">
								<div class="muban" @click="$router.push(`/kongEditor?index=${0}`)">
									<div>
										<img src='../../assets/images/muban.png' alt="">
										<p>从空白模板创建</p>
									</div>
								</div>
								<div class="muban" v-if='$store.state.releaseInfo[0].id'
									@click="$router.push(`/histroyEditor?index=${0}`)">
									<div>
										<img src='../../assets/images/muban.png' alt="">
										<p>从上次修改创建</p>
									</div>
								</div>
								<div class="muban" v-for="(item,index) in zyTemplate" :key="item.id"
									@click="toMbDetail(item.id,0)">
									<div>
										<img src='../../assets/images/muban.png' alt="">
										<p>{{item.name}}</p>
									</div>
								</div>
							
							</div>
							<!-- <p style="color: #888888;margin: 20px 0;">未保护知识产权，解决方案强制要求加密，将向对方发生带水印的科追踪版本。</p>
							<p style="color: #888888;">
								设置加密密码
							<input type="text" style="margin: 0 10px; width: 117px;height: 31px;border: 1px solid #D2D2D2;" v-model="form1.pwd">
							<span style="margin-left: 20px;">是否在水印中显示您的用户名：</span>
							<el-radio-group v-model="form1.shuiYinRadio">
							    <el-radio :label="1">是</el-radio>
							    <el-radio :label="2">否</el-radio>
							  </el-radio-group>
							</p> -->
						</div>
					</div>
					<div class="form-item">
						<div style="display: flex;width: 100%;align-items: center;">
							<div class="jtitle">
								联系方式：
							</div>
							<div>
								<input v-model="form1.phone" type="text" placeholder="请输入手机号或邮箱" style="padding: 0 15px; width: 800px;height: 40px;border: 1px solid #D2D2D2;">
							</div>
						</div>
					</div>


				</div>

				<div v-if="nowWeAre == 3"> <el-result icon="success" title="提交成功,等待审核..." subTitle="">
						<template slot="extra">
						</template>
					</el-result>
					<p style="margin: auto;text-align: center;cursor: pointer;" class="gocheck"
						@click="$router.push(`/userCenter/pthd/projectNeed`)">去个人中心查看审核状态</p>
					</div>
				<div class="nextStep" v-if="nowWeAre == 1" @click='productAssistanceHandler'>提交</div>
			</div>
			<div class="body-right">
				<div style="background: #0052D9;"   @click="$router.push('/userCenter/drafts')">
					<img src='../../assets/images/create.png' alt="" style="width: 18px;height: 18px;"><span
						style="width:100px">从草稿中创建</span>
				</div>
				<div style="background: #18BC9C;" @click='saveCaoGao'>
					<img src='../../assets/images/caogao.png' alt="" style="width: 19px;height: 19px;">
					<span style="width:100px">保存至草稿箱</span>
				</div>

				<div style="background:#444C69;" @click='productAssistanceHandler'>
					<img src='../../assets/images/yeah.png' alt="" style="width: 18px;height: 16px;"><span
						style="width:100px">完成</span>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import isEmpty from '../../utils/isEmpty.js'
	export default {
		data() {

			return {
				type: '123',
				nowWeAre: 1,
				//form1
				arrowStep:1,
				form1: {
					producthelp_id:'',
					summary:'',
					draft:0,
					phone:''
				},
				//form2

				serveCode: 1234,
				dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				chooseKeyWords: [],
				zyTemplate: [],
			}
		},
		async created() {
			 this.getTemplateLists()
			await this.getDraftDetail()
			const release = [{
					id:this.form1.summary,
					first_id: '',
				},
			]
			// this.form1.producthelp_id = this.$route.query.id
			this.$store.commit('init_releaseInfo', release)
		},
		watch: {
			'$store.state.releaseInfo': {
				handler(n, o) {
					this.form1.summary = this.$store.state.releaseInfo[0].id
				},
				deep: true,
				immediate: true
			},
		
		},
		methods: {
			async getDraftDetail(){
				const detail = await this.$api.getProductYZDraftDetail({id:this.$route.query.id})
				this.form1.summary = detail.data.summary
				this.form1.phone = detail.data.phone
				this.form1.producthelp_id = detail.data.producthelp_id
				this.form1.id = detail.data.id
				// this.getToolDetail(detail.data.schemehelp_id)
			},
			async saveCaoGao(){
				this.form1.draft = 1
				// this.serveData.project_need_files = this.serveData.project_need_files.join(',')
				const project = await this.$api.productAssistance({
					...this.form1
				})
				if (project.code == 1) {
					this.$message({
						message: project.msg,
						type: 'success'
					})
					location.reload()
				} else {
					this.$message({
						message: project.msg,
						type: 'warning'
					})
				}
			},
		 async productAssistanceHandler(){
			 this.form1.draft = 0
				const project = await this.$api.productAssistance({...this.form1})
				if (project.code == 1) {
					this.$message({
						message: project.msg,
						type: 'success'
					})
					this.nowWeAre = 3
					this.arrowStep = 3
				} else {
					this.$message({
						message: project.msg,
						type: 'warning'
					})
				}
			},
			async getTemplateLists() {
				const zy = await this.$api.templateLists({
					templatecate_id:19
				})
				this.zyTemplate = zy.data
				
			},
			toMbDetail(id, index) {
				this.$router.push(`/editor?id=${id}&index=${index}`)
			},
		}
	}
</script>
<style>
	.header {
		.backof {
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}

		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;

		&>div {
			&>img {
				width: 16px;
				height: 16px;
			}

			&>p {
				font-size: 16px;
				margin-left: 10px;

				&>span {
					color: #888888;
				}
			}
		}
	}

	/* .el-radio__label {
		color: black;
	}

	.radio {
		position: relative;
		display: inline-block;
		margin-right: 12px;
	}

	.radio input {
		width: 15px;
		height: 15px;
		appearance: none;
		-webkit-appearance: none;
		opacity: 0;
		outline: none;
	}

	.radio label {
		position: absolute;
		left: 0;
		top: 6px;
		width: 15px;
		height: 15px;
		border: 1px solid #bcbcbc;
	}

	.el-radio__inner {
		border-radius: 0;
	}

	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	} */

	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}

	#taginp {
		height: 32px;
	}
</style>
<style scoped lang="less">
	.choose{
		background: #0052D9 !important;
	}
	.keywords {
		cursor: pointer;
		margin-right: 20px;
		width: 148px;
		height: 46px;
		background: #F6F6F6;
		border: 1px solid #E5E5E5;
		line-height: 46px;
		text-align: center;
	}

	.captcha-row {
		display: flex;

		.captcha-button {
			background: #048fff;
			color: white;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 4rpx 8rpx;
			width: 320rpx;
			border-radius: 4rpx;
		}
	}

	.getCode {
		width: 133px;
		height: 40px;
		background: #0052D9;
		border: 1px solid #D2D2D2;
		color: white;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}

	/deep/.el-input__inner {
		height: 46px;
		border: 1px solid #D2D2D2;
	}

	.nextStep {
		width: 261px;
		height: 40px;
		margin: 0 auto;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
		color: white;
		font-size: 18px;
		background: #0052D9;
	}

	.form-one {

		padding: 20px;
		padding-right: 40px;
		box-sizing: border-box;

		.form-item {
			.bottom {
				margin-top: 30px;
			}

			.inpt {
				width: 855px;
				height: 46px;
			}

			input[type=checkbox] {
				cursor: pointer;
				position: relative;
				width: 18px;
				height: 16px;
				font-size: 12px;
			}

			input[type=checkbox]::after {
				position: absolute;
				top: 0;
				color: #000;
				width: 18px;
				height: 16px;
				display: inline-block;
				visibility: visible;
				padding-left: 0px;
				text-align: center;
				content: ' ';
				border-radius: 3px
			}

			input[type=checkbox]:checked::after {
				content: "✓";
				color: #fff;
				font-size: 12px;
				font-weight: bold;
				background-color: #0052D9;
			}

			.jtitle {
				width: 150px;
			}

			.item-content {
				flex: 1;
				display: flex;
				overflow-x: auto;
				white-space: nowrap;
				.muban {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 148px;
					flex-shrink: 0;
					height: 148px;
					background: #F6F6F6;
					cursor: pointer;
					margin-left: 50px;
					&>div {
						display: flex;
						justify-content: center;
						flex-wrap: wrap;
					}

					p {
						width: 100%;
						text-align: center;
						margin-top: 10px;
					}
					&:first-child {
						margin-left: 0;
					}
				}
			}

			display: flex;
			flex-wrap: wrap;
			width: 100%;
			margin: 20px 0 40px 0;
		}

		.laterUp {
			display: flex;
			align-items: center;


		}
	}

	.box,
	.box-f,
	.box-l {
		position: relative;
		/* 设置元素定位的基准 */
		width: 270px;
		height: 48px;
		background-color: #F6F6F6;
		margin-left: 24px;
		text-align: center;
		line-height: 48px;
		font-size: 18px;
	}

	/* 设置前面板（上半部分） */
	.box::before,
	.box-f::before {
		content: '';
		position: absolute;
		/* 相对于父元素进行绝对定位 */
		right: 0;
		transform: translateX(100%) rotate(90deg);
		/* 旋转45度 */
		width: 0;
		/* 去掉宽度 */
		height: 0;
		/* 去掉高度 */
		border-width: 24px;
		border-style: solid;
		border-color: transparent transparent #F6F6F6 transparent;
	}

	.box::after,
	.box-l::after {
		content: '';
		position: absolute;
		/* 相对于父元素进行绝对定位 */
		left: 0;
		transform: rotate(90deg);
		/* 旋转45度 */
		width: 0;
		/* 去掉宽度 */
		height: 0;
		/* 去掉高度 */
		border-width: 24px;
		border-style: solid;
		border-color: transparent transparent white transparent;
	}

	.box-active,
	{
	background: #0052D9;
	color: white;
	}

	.box-active::before {
		border-color: transparent transparent #0052D9 transparent;
	}

	/* 设置后面板（下半部分） */

	.left {
		padding: 25px 0;
		box-sizing: border-box;
		width: 1180px;
		margin-bottom: 50px;
		background: #FFFFFF;
	}

	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			line-height: 50px;
			width: 200px;
			height: 50px;
			background: #0052D9;

			&>img {
				margin-right: 15px;
			}
		}
	}
</style>